import React from 'react'
import Link from '@mui/material/Link'
import ImageGallery from 'react-image-gallery'
import "react-image-gallery/styles/css/image-gallery.css"
import PanelHeader from "./PanelHeader"

export default function Eddi() {
    const maptitles = {
      'EDDI_01wk': '1-Week',
      'EDDI_02wk' : '2-Week',
      'EDDI_03wk' : '3-Week',
      'EDDI_01mn' : '1-Month',
      'EDDI_02mn' : '2-Month',
      'EDDI_03mn' : '3-MOnth',
    }
    const mapurl = 'https://nedews.nrcc.cornell.edu/EDDI_maps/'

    let eddiMaps = []
    Object.keys(maptitles).forEach((t) => {
      const mapname = mapurl + t + ".png"
      eddiMaps.push({
        original: mapname,
        thumbnail: mapname,
        thumbnailLabel: maptitles[t] || ""
      })
    })

    const panelTitle = "Evaporative Drought Demand Index"

    return (
      <>
        <PanelHeader
          title={panelTitle}
        />
        <div className="mapandlegend-container">
          <ImageGallery 
            items={eddiMaps} 
            thumbnailPosition="bottom"
            showFullscreenButton={false}
            showPlayButton={false}
            showNav={false}
            slideDuration={200}
            slideInterval={9999}
            startIndex={3}
          />
          <div style={{textAlign:"center", margin:"1em 0"}}>
            <Link href="https://wwa.colorado.edu/sites/default/files/2023-06/EDDI_2-pager.pdf" target="_blank" rel="noreferrer">
              More information about EDDI
            </Link>
          </div>
        </div>
      </>
    )
}